import { cn } from '../../lib/cn'
import type { SetorDoAutor } from '../../types/repositorios'
import { ajudaDoSetor, CLASSE_DO_SETOR, rotuloDoSetor } from './setores'

/**
 * A etiqueta do setor de quem fez o commit.
 *
 * Preenchimento claro e texto escuro, como as etiquetas de estado: a cor liga a pessoa ao setor
 * de uma tabela para a outra, e o `title` traz a ajuda para quem parar o mouse — o texto por
 * extenso mora no glossário.
 */
export function EtiquetaDeSetor({ setor, className }: { setor: SetorDoAutor; className?: string }) {
  return (
    <span
      title={ajudaDoSetor(setor)}
      className={cn(
        'inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset',
        CLASSE_DO_SETOR[setor] ?? CLASSE_DO_SETOR.SEM_VINCULO,
        className,
      )}
    >
      {rotuloDoSetor(setor)}
    </span>
  )
}
